export default class Result {

    static CATEGORY_CHILD = 'child';
    static CATEGORY_EMPLOYEE = 'employee';
    static CATEGORY_GROUP = 'group';
    static CATEGORY_INVOICE = 'invoice';
    static CATEGORY_MEMBER = 'member';
    static CATEGORY_PARENT_USER = 'parentUser';

    static INSTITUTION_TYPE_KINDERGARTEN = 'kindergarten';
    static INSTITUTION_TYPE_CLUB = 'club';

    constructor() {
        this.identity = null;
        this.category = null;
        this.type = null;
        this.title = null;
        this.image = null;
        this.link = null;
        this.match = null;
        this.institutionName = null;
        this.institutionType = null;
        this.contractStatus = null;
        this.contractState = null;
        this.membershipNumber = null;
        this.accountsReceivableNumber = null;
    }

    static fromData(data){
        if (!data) {
            return;
        }

        let result = new Result();
        result.identity = data.identity;
        result.category = data.category;
        result.type = data.type;
        result.title = data.title;
        result.image = data.image;
        result.link = data.link;
        result.match = data.match;
        result.institutionName = data.institutionName;
        result.institutionType = data.institutionType;
        if (null !== data.contractStatus) {
            result.contractStatus = data.contractStatus;
        }
        if (null !== data.contractState) {
            result.contractState = data.contractState;
        }
        if (null !== data.age) {
            result.age = data.age;
        }
        if (null !== data.membershipNumber) {
            result.membershipNumber = data.membershipNumber;
        }
        if (null !== data.accountsReceivableNumber) {
            result.accountsReceivableNumber = data.accountsReceivableNumber;
        }

        return result;
    }

    isKindergartenEmployee() {
        return this.category === Result.CATEGORY_EMPLOYEE
            && this.institutionType === Result.INSTITUTION_TYPE_KINDERGARTEN;
    }
}
